module.exports = __webpack_public_path__ + "img/logo.b8c3b762.png";